// @flow
import { Button, ComboBoxInput, Icon } from 'bench-internal-theme';
import { Grid } from 'layout-core-components';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';

import type { PersonSearchResult } from './types';

const OptionCompany = styled.span`
  color: ${colors.dust};
  margin-left: 4px;
`;

const convertPersonToOption = ({ company, fullName, id }) => ({
  label: (
    <Fragment>
      <span>{fullName}</span>
      <OptionCompany>{company}</OptionCompany>
    </Fragment>
  ),
  value: id,
});

const OptionNewUser = styled.span`
  color: ${colors.water};

  ${Icon} {
    margin: 0 2px 0 0;
    vertical-align: text-top;
  }
`;

const newUserOption = {
  label: (
    <OptionNewUser>
      <Icon color={colors.water} icon="plus" size="14px" />
      Create New User
    </OptionNewUser>
  ),
  value: '-1',
};

type SearchAndAssignPersonProps = {
  attachSelectedPersonToClient: () => void,
  autoFocus?: boolean,
  isLoading?: boolean,
  menuIsOpen?: boolean,
  onRequestCreateNewPerson?: () => void,
  onSearchStringChanged: string => void,
  onSelectedPersonChanged: any => void,
  persons: Array<PersonSearchResult>,
  searchString?: string,
  selectedPerson?: Object,
  submitLabel: string,
};

const SearchAndAssignPerson = ({
  attachSelectedPersonToClient,
  autoFocus,
  isLoading,
  menuIsOpen,
  onRequestCreateNewPerson,
  onSearchStringChanged,
  onSelectedPersonChanged,
  persons,
  searchString,
  selectedPerson,
  submitLabel,
}: SearchAndAssignPersonProps) => {
  const personOptions = persons.map(convertPersonToOption);
  const options =
    typeof onRequestCreateNewPerson === 'function'
      ? [newUserOption, ...personOptions]
      : personOptions;
  return (
    <Grid columnSpacing="small" row="288px 192px">
      <ComboBoxInput
        autoFocus={autoFocus}
        blurInputOnSelect
        closeMenuOnSelect
        filterOption={() => true}
        iconDecoration="search"
        inputValue={searchString}
        isClearable
        isCreatable
        isLoading={isLoading}
        isSearchable
        menuIsOpen={menuIsOpen || undefined}
        noOptionsMessage={() => 'Users that match the search term appear here.'}
        onChange={selectedOption => {
          if (!selectedOption) {
            onSelectedPersonChanged(null);
            return;
          }
          if (
            selectedOption.value === newUserOption.value &&
            typeof onRequestCreateNewPerson === 'function'
          ) {
            onRequestCreateNewPerson();
          } else {
            const newSelectedPerson = persons.find(({ id }) => id === selectedOption.value);
            onSelectedPersonChanged(newSelectedPerson);
          }
        }}
        onInputChange={onSearchStringChanged}
        options={options}
        placeholder=""
        value={selectedPerson && convertPersonToOption(selectedPerson)}
      />
      <Button onClick={attachSelectedPersonToClient} styleType="primary">
        {submitLabel}
      </Button>
    </Grid>
  );
};

SearchAndAssignPerson.defaultProps = {
  autoFocus: false,
  isLoading: false,
  menuIsOpen: false,
  onRequestCreateNewPerson: undefined,
  searchString: '',
  selectedPerson: null,
};

export default SearchAndAssignPerson;
